import type Phaser from 'phaser';

export const STOPPABLE_SCENE_KEYS = [
  'TitleScene',
  'TutorialScene',
  'EndingScene',
  'HorizontalBattleScene',
  'HubScene',
  'TowerScene',
  'ResultScene',
] as const;

export type StoppableSceneKey = (typeof STOPPABLE_SCENE_KEYS)[number];

interface SceneManagerLike {
  isActive: (key: string) => boolean;
  stop: (key: string) => void;
}

interface GameLike {
  scene: SceneManagerLike;
}

export function stopActiveGameScenes(game: GameLike | null | undefined): void {
  if (!game) return;
  for (const key of STOPPABLE_SCENE_KEYS) {
    if (game.scene.isActive(key)) {
      game.scene.stop(key);
    }
  }
}

export function startSceneClean(
  game: Phaser.Game | GameLike,
  targetKey: StoppableSceneKey,
): void {
  stopActiveGameScenes(game);
  (game.scene as unknown as { start: (k: string) => void }).start(targetKey);
}
